import React from 'react';

import { UserOutlined } from '@ant-design/icons';

import { Avatar, Dropdown } from 'antd';
import { AuthService } from 'basealpha-ui';

const UserMenu = (): React.ReactElement => {
  const logout = (): void => {
    const service = new AuthService();
    service.signOut();
  };

  return (
    <Dropdown menu={{
      items: [
        {
          key: '0',
          label: 'Logout',
          onClick: logout,
        },
      ]
    }} trigger={['click']}>
      <Avatar icon={<UserOutlined />} />
    </Dropdown>
  );
};

export default UserMenu;
